import type { ValueEvent } from '@adornis/base/utilTypes.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { CampusExercise } from '@chancenwerk/campus-learning-content/entities/CampusExercise.js';
import '@chancenwerk/components/chancen-component-card-title.js';
import { ExerciseType } from '@chancenwerk/db/enums/enums.js';
import { html, nothing, type PropertyValueMap } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import SmilesDrawer from 'smiles-drawer/src/SmilesDrawer';
import { CampusComponentExerciseEdit } from './campus-page-exercise-edit.js';

/**
 * @customElement campus-page-exercise-edit-chemistry-formular
 */
@customElement('campus-page-exercise-edit-chemistry-formular')
export class CampusPageExerciseEditChemistryFormula extends CampusComponentExerciseEdit {
  static override exerciseType: number = ExerciseType.CHEMISTRY_FORMULA;
  static override exerciseName: string = 'Chemie-Formel';
  static override exerciseElement: string = 'campus-page-exercise-edit-text';

  @state() private readonly _chemistryFormula = new RXController(this, '');

  protected override getExcersiseType(): number {
    return CampusPageExerciseEditChemistryFormula.exerciseType;
  }

  protected override getExcersieName(): string {
    return CampusPageExerciseEditChemistryFormula.exerciseName;
  }

  constructor() {
    super();
  }

  protected override async handleFormSuccess(exercise: CampusExercise): Promise<void> {
    if (exercise.chemistryFormula === '') return this.errorMsg.next('Bitte eine Formel eingeben!');
    return super.handleFormSuccess(exercise);
  }

  override updated(changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.updated(changedProperties);
    const svgTarget = this.shadowRoot?.querySelector('#svgExample');
    const drawer = new SmilesDrawer();
    drawer.draw(this._chemistryFormula.value, svgTarget);
  }

  override content() {
    return html`
      ${this.errorMsg.value ? html`<cr-text ${css({ color: 'red' })}>${this.errorMsg.value}</cr-text>` : nothing}
      <cr-card space="md" padding="md">
        <cr-flex horizontal space="md">
          <cr-flex flex space="md">
            <cr-flex space="md" space-between>
              <cr-text>Felder mit einem * müssen ausgefüllt werden!</cr-text>
              <cr-input ${this.form.field('title')} placeholder="Titel *"></cr-input>
              <cr-text
                >Für die Formeln muss der Strukturcode
                <cr-link
                  href="https://de.wikipedia.org/wiki/Simplified_Molecular_Input_Line_Entry_Specification"
                  target="_blank"
                >
                  <cr-text>SMILES</cr-text>
                </cr-link>
                verwendet werden.
              </cr-text>
              <cr-input
                .value=${this.form.document?.chemistryFormula}
                @value-picked=${(e: ValueEvent<string>) => {
                  this._chemistryFormula.next(e.detail.value);

                  if (!this.form.document) return;
                  this.form.document.chemistryFormula = e.detail.value;
                }}
                @value-changed=${(e: ValueEvent<string>) => {
                  this._chemistryFormula.next(e.detail.value);
                }}
                placeholder="Chemieformel *"
              >
              </cr-input>
              <svg id="svgExample" height="250"></svg>
            </cr-flex>
          </cr-flex>
        </cr-flex>
      </cr-card>
    `;
  }
}
